import { render, staticRenderFns } from "./bulletinAdd.vue?vue&type=template&id=461ce1ff&scoped=true"
import script from "./bulletinAdd.vue?vue&type=script&lang=js"
export * from "./bulletinAdd.vue?vue&type=script&lang=js"
import style0 from "./bulletinAdd.vue?vue&type=style&index=0&id=461ce1ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ce1ff",
  null
  
)

export default component.exports